import React, { useEffect, useRef, useState } from "react";
import { Select, Checkbox } from "antd";
import { IoIosArrowDown } from "react-icons/io";

const MultiSelectDropdown = ({
  className,
  lableName,
  options,
  selectedValues,
  setSelectedId,
  fetchMoreData, // This is the new function that handles fetching more data
  hasMoreData, // Boolean to indicate if there's more data to fetch
}) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const dropdownRef = useRef();

  useEffect(() => {
    if (selectedValues) {
      const selectedLabels = options
        ?.filter((option) => selectedValues?.includes(option.value))
        ?.map((option) => option.label);
      setSelectedItems(selectedLabels);
    }
  }, [selectedValues, options]);

  const handleCheckboxChange = (option) => {
    const updatedSelectedItems = selectedItems?.includes(option.label)
      ? selectedItems?.filter((item) => item !== option.label)
      : [...selectedItems, option.label];

    setSelectedItems(updatedSelectedItems);

    setSelectedId((prevSelectedItems) =>
      prevSelectedItems?.includes(option.value)
        ? prevSelectedItems.filter((item) => item !== option.value)
        : [...prevSelectedItems, option.value]
    );
  };

  const handleDeselect = (value) => {
    const option = options.find((option) => option.label === value);

    setSelectedItems((prevSelectedItems) =>
      prevSelectedItems.filter((item) => item !== value)
    );

    if (option) {
      setSelectedId((prevSelectedItems) =>
        prevSelectedItems.filter((item) => item !== option.value)
      );
    }
  };

  const handleScroll = (e) => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight,
      scrollLeft,
      scrollWidth,
      clientWidth,
    } = e.target;

    // Check if scrolling down (Y-axis)
    const bottomY = scrollHeight - scrollTop === clientHeight;

    // Check if not scrolling horizontally (X-axis)
    const isHorizontalScroll = scrollWidth > clientWidth && scrollLeft > 0;

    if (bottomY && hasMoreData && !isHorizontalScroll) {
      fetchMoreData(); // Trigger the fetchMoreData function only on vertical scroll
    }
  };

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {lableName && <label htmlFor="lableName">{lableName}</label>}
      <Select
        placeholder="Select Store"
        className="w-full h-[50px]"
        mode="multiple"
        value={selectedItems}
        onDeselect={handleDeselect}
        dropdownRender={() => (
          <div
            ref={dropdownRef}
            onScroll={handleScroll}
            className="custom-dropdown grid grid-cols-2 max-h-[150px] overflow-y-auto custom-scrollbar"
          >
            {options.map((option) => (
              <div key={option.value} className="flex items-center px-2 py-1">
                <Checkbox
                  checked={selectedItems?.includes(option?.label)}
                  onChange={() => handleCheckboxChange(option)}
                  className="custom-checkbox"
                >
                  {option?.label}
                </Checkbox>
              </div>
            ))}
          </div>
        )}
        suffixIcon={<IoIosArrowDown className="text-gray-500" size={24} />}
      />
    </div>
  );
};

export default MultiSelectDropdown;
